import { useAuth } from '../context/AuthContext';
import { useLocation, Link } from 'react-router-dom';
import UserDropdown from './UserDropdown';

/**
 * Header component with user info and logout
 */
export default function Header() {
  const { user } = useAuth();
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <header className="sticky top-0 z-40 bg-dark-800/95 backdrop-blur-sm border-b border-dark-600">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 no-underline" aria-label="Go to home">
            <div className="w-8 h-8 rounded-lg overflow-hidden bg-primary flex items-center justify-center" aria-hidden="true">
              <img
                src="/logo-300x300.png"
                alt="Clipto logo"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-bold text-lg" role="heading" aria-level="1">Clipto</span>
          </Link>

          {/* Admin link moved to user dropdown */}
        </div>

        {/* User menu */}
        {user && <UserDropdown />}
      </div>
    </header>
  );
}
